export default {
    data: {
        isAgree: false,
        account: "",
        password: ""
    },
    rule: {
        account: {
            type: "Empty",
            message: "登录账号不合法,只能是6-16位的字母或数字，且必须含字母"
        },
        password: {
            type: "Empty",
            message: "登录密码不合法,只能是6-16位的字母或数字，且必须含字母"
        }
    }
};